import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";
import { Room, RoomCreate, RoomLight, RoomUpdate } from "../models/room";
import { map } from "rxjs/operators";
import { UserNotify } from "src/app/support/notify-decorator";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { pickBy } from "lodash";

@Injectable()
export class RoomBackend {
  private readonly http = inject(HttpClient);

  load(id: string): Observable<Room> {
    return this.http.get<Room>(
      `${environment.snoots.api.healthcare}/rooms/${id}`
    );
  }

  loadLight(id: string): Observable<RoomLight> {
    return this.http.get<RoomLight>(
      `${environment.snoots.api.healthcare}/rooms/${id}`,
      {
        params: {
          light: "true"
        }
      }
    );
  }

  list({
    page,
    size,
    light,
    tenant
  }: {
    page: number;
    size: number;
    light?: boolean;
    tenant?: string;
  }): Observable<PaginatedResult<Room>> {
    return this.http.get<PaginatedResult<Room>>(
      `${environment.snoots.api.healthcare}/rooms`,
      {
        params: pickBy<any>({
          p: `${page}`,
          s: `${size}`,
          light: light,
          tenant
        })
      }
    );
  }

  listAll(): Observable<Room[]> {
    return this.list({
      page: 1,
      size: 10000
    }).pipe(map((response) => response.docs));
  }

  listAllLight(tenant?: string): Observable<RoomLight[]> {
    return this.list({
      page: 1,
      size: 10000,
      light: true,
      tenant
    }).pipe(map((response) => response.docs));
  }

  @UserNotify({
    successMessage: marker("Stanza creata"),
    errorMessage: marker("Impossibile creare la stanza")
  })
  create(payload: RoomCreate): Observable<void> {
    return this.http.post<void>(
      `${environment.snoots.api.healthcare}/rooms`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Stanza aggiornata"),
    errorMessage: marker("Impossibile aggiornare la stanza")
  })
  update(id: string, payload: RoomUpdate): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.healthcare}/rooms/${id}`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Stanza rimossa"),
    errorMessage: marker("Impossibile rimuovere la stanza")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.healthcare}/rooms/${id}`
    );
  }
}
